export const VERTICALS_FETCH_COMPLETE = "verticals fetch complete";
export const PAGEVERTICALS_FETCH_COMPLETE = 'pageverticals_fetch_complete';
export const VERTICALS_UPDATED= "verticals updated";
export const PAGEVERTICALS_UPDATED= "pageverticals updated";
